import {QTableColumn} from 'pansx-utils';
import {CustomerBank} from "@/entity/CustomerBank";

export class Customer {
    public id?: number;
    public name = '';
    public legalPerson = '';
    public legalPersonIdCode = '';
    public businessLicense = '';
    public creatorId = 0;
    public isReviewPass?: boolean;
    public registeredCapital?: number;      //注册资本
    public registerCurrency = '';           //注册币种
    public country?: number;                //国别  1 国内   0 国外
    public nation = '';                     //国家
    public province = '';                   //省
    public city = '';                       //市
    public district = '';                   //县
    public address = '';                    //详细地址
    public authorizedPerson = '';           //法定授权人
    public authorizationDeadline?: Date;    //授权截止日期
    public authorizedAttachment = '';       //授权附件
    public creditCode = '';                 //统一社会信用代码
    public licenseExpirationDate?: Date;    //营业执照失效日期
    public licenseAttachment = '';          //营业执照附件
    public customerBankList: CustomerBank[] = [];
    public rejectReason = ''; //拒绝理由

    public bankAccount = '';
    public bankName = '';
    public static of(o: unknown): Customer {
        return Object.assign(new Customer(), o);
    }

    public static getColumns(): QTableColumn[] {
        return [
            {name: 'id', field: 'id', label: '序号'},
            {name: 'name', field: 'name', label: ''},
            {name: 'legalPerson', field: 'legalPerson', label: '法人'},
            // {
            //     name: 'legalPersonIdCode',
            //     field: 'legalPersonIdCode',
            //     label: '法人身份证代码',
            // },
            // {
            //     name: 'businessLicense',
            //     field: 'businessLicense',
            //     label: '营业执照',
            // },
            // {name: 'creatorId', field: 'creatorId', label: '创建者id'},
            // {
            //     name: 'isReviewPass',
            //     field: 'isReviewPass',
            //     label: '审查通过了吗',
            // },{
            //     name: 'registeredCapital',
            //     field: 'registeredCapital',
            //     label: '注册资本',
            // },{
            //     name: 'registerCurrency',
            //     field: 'registerCurrency',
            //     label: '注册币种',
            // },{
            //     name: 'country',
            //     field: 'country',
            //     label: '国别',
            // },{
            //     name: 'nation',
            //     field: 'nation',
            //     label: '国家',
            // },{
            //     name: 'province',
            //     field: 'province',
            //     label: '省',
            // },{
            //     name: 'city',
            //     field: 'city',
            //     label: '市',
            // },{
            //     name: 'district',
            //     field: 'district',
            //     label: '县',
            // },{
            //     name: 'address',
            //     field: 'address',
            //     label: '详细地址',
            // },
            // {
            //     name: 'authorizedPerson',
            //     field: 'authorizedPerson',
            //     label: '法定授权人',
            // },{
            //     name: 'authorizationDeadline',
            //     field: 'authorizationDeadline',
            //     label: '授权截止日期',
            // },
            // {
            // //     name: 'authorizedAttachment',
            // //     field: 'authorizedAttachment',
            // //     label: '授权附件',
            // // },{
            // //     name: 'creditCode',
            // //     field: 'creditCode',
            // //     label: '统一社会信用代码',
            // // },{
            //     name: 'licenseExpirationDate',
            //     field: 'licenseExpirationDate',
            //     label: '营业执照失效日期',
            // },
            // {
            //     name: 'licenseAttachment',
            //     field: 'licenseAttachment',
            //     label: '营业执照附件',
            // },
        ];
    }

    public toRole(s = '') {
        const r = 'ROLE_CUSTOMER_' + this.id;
        if (s === '') {
            return r;
        } else {
            const s1 = r + '_' + s.toUpperCase();
            return s1;
        }

    }

    public getColumnLabel(field: string) {
        const columns = Customer.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field,
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}
